import { useQuery } from '@tanstack/react-query';
import { getAllPropertyDocumentServices } from '../service';

function useDocumentServices() {
    const documentTypesQuery = useQuery({
        queryKey: ['property-documents', 'services'],
        queryFn: async () => getAllPropertyDocumentServices(),
    });

    return documentTypesQuery;
}

export { useDocumentServices };
